/*
  <hayat-results>: تبويبين (شعر / بشرة) بقسم النتائج حسب المشكلة. الضغط يبين لوحة التبويب ويخفي الثانية،
  والأسهم يمين/يسار تتنقل بين التبويبين (سلوك tablist المعتاد).
*/
if (!customElements.get('hayat-results')) {
  customElements.define(
    'hayat-results',
    class HayatResults extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(tab.dataset.tab));
          tab.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            event.preventDefault();
            const next = this.tabs[(i + 1) % this.tabs.length];
            next.focus();
            this.select(next.dataset.tab);
          });
        });
      }

      select(name) {
        this.dataset.active = name;
        this.tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.tab === name)));
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.panel !== name;
        });
      }
    }
  );
}
